<template>
  <div class="app-content content">
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h2 class="content-header-title mb-0">
                My OSH Conversations
              </h2>
            </div>
          </div>
        </div>
      </div>

      <div class="content-body content-body--senior-call">
        <div class="row">
          <div class="col-12">
            <CompleteTable
              :sorted-field="sortedField"
              :data="conversations"
              :sort-mapping="sortMapping"
              :title="'OSH conversations'"
              :total="conversationsTotal"
              :filter-path="'conversations/filter'"
            >
              <template v-slot="{field}">
                <td class="text-end">
                  <a
                    :href="$router.resolve({ name: 'researcher.conversations.show', params: { id: field.id }, query: { actAs: $route.query.actAs } }).href"
                    class="btn btn-sm btn-outline-primary"
                    target="_blank"
                  >
                    <i data-feather="message-circle" /> Open
                  </a>
                </td>
              </template>
            </CompleteTable>
          </div>
        </div>
      </div>
    </div>

    <ConvoFilter filter-path="conversations/filter">
      <template #filters>
        <div class="mb-1">
          <label class="form-label">Status</label>
          <select
            v-model="filters.status"
            class="form-select"
            @change="saveFilter({ customLabel: true, name: `Status: ${$event.target.options[$event.target.selectedIndex].text}`, value: $event.target.value }, 'status')"
          >
            <option value="">All</option>
            <option value="pending">Pending</option>
            <option value="replied">Replied</option>
            <option value="closed">Closed</option>
          </select>
        </div>
        <hr>
        <div class="mb-1">
          <label class="form-label">Date from</label>
          <input
            v-model="filters.date_from"
            type="date"
            class="form-control"
            @change="saveFilter({ customLabel: true, name: `From: ${$event.target.value}`, value: $event.target.value }, 'date_from')"
          >
        </div>
        <div class="mb-1">
          <label class="form-label">Date to</label>
          <input
            v-model="filters.date_to"
            type="date"
            class="form-control"
            @change="saveFilter({ customLabel: true, name: `To: ${$event.target.value}`, value: $event.target.value }, 'date_to')"
          >
        </div>
      </template>
    </ConvoFilter>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CompleteTable from '../../partials/components/CompleteTable.vue'
import ConvoFilter from '../../partials/offcanvas/ConvoFilter.vue'

export default {
  components: {
    CompleteTable,
    ConvoFilter,
  },
  data() {
    return {
      sortedField: 'Last activity',
      defaultFields: [
        { name: 'Code', checked: true, order: 0 },
        { name: 'Title', checked: true, order: 1 },
        { name: 'Last message', checked: true, order: 2 },
        { name: 'Status', checked: true, order: 3 },
        { name: 'Last activity', checked: true, order: 4 },
      ],
      sortMapping: {
        Code: 'code',
        Title: 'title',
        'Last message': 'last_message_preview',
        Status: 'status_badge',
        'Last activity': 'last_activity',
      },
    }
  },
  computed: {
    ...mapGetters({
      fields: 'modals/tableSettingsFields',
      conversations: 'conversations/conversations',
      conversationsTotal: 'conversations/conversationsTotal',
      filters: 'filters/filters',
    }),
  },
  async mounted() {
    await this.$store.dispatch('conversations/filter')
    await this.$store.dispatch('modals/fetchUserFields', 'researcher_conversations')
    if (!this.fields || this.fields.length === undefined) {
      await this.$store.dispatch('modals/fetchFields', {
        fields: this.defaultFields,
        table: 'researcher_conversations',
      })
    }
    setTimeout(() => {
      // eslint-disable-next-line no-undef
      feather.replace({ width: 14, height: 14 })
    }, 500)
  },
  methods: {
    saveFilter(value, field) {
      if (!value || (!value.value && value.value !== 0)) {
        this.$store.dispatch('filters/deleteFilters', field)
      } else {
        this.$store.dispatch('filters/saveFilters', { value, field })
      }
    },
  },
}
</script>
